import { ChevronDown } from "lucide-react";
import { Reveal } from "./Reveal";
import { FAQ, FAQ_GROUPS } from "../data/faq";

// Accordion nativo <details>/<summary>: il testo delle risposte è sempre nell'HTML (anche senza JavaScript
// e negli snapshot per i crawler). Una sola domanda aperta per gruppo (attributo `name` + fallback JS).
const closeSiblings = (e) => {
    const el = e.currentTarget;
    if (!el.open) return;
    el.parentElement.querySelectorAll("details[open]").forEach((d) => {
        if (d !== el) d.open = false;
    });
};

const FaqItem = ({ item, index, group }) => (
    <details
        name={group}
        onToggle={closeSiblings}
        data-testid={`faq-item-${index}`}
        className="group border-b border-slate-200 last:border-b-0"
    >
        <summary
            data-testid={`faq-question-${index}`}
            className="flex cursor-pointer select-none list-none items-center justify-between gap-4 py-5 text-left text-base font-bold text-[#0B1F3A] sm:text-lg [&::-webkit-details-marker]:hidden"
        >
            <span>{item.q}</span>
            <ChevronDown className="h-4 w-4 shrink-0 text-[#E30613] transition-transform duration-200 group-open:rotate-180" aria-hidden="true" />
        </summary>
        <div
            data-testid={`faq-answer-${index}`}
            className="whitespace-pre-line pb-6 text-left text-base leading-relaxed text-[#475569]"
        >
            {item.a}
        </div>
    </details>
);

export const Faq = () => (
    <section id="faq" data-testid="faq-section" className="bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16">
            <div className="grid gap-10 lg:grid-cols-12 lg:gap-16">
                <div className="lg:col-span-4">
                    <Reveal>
                        <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#E30613]">Domande frequenti</span>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-[#0B1F3A] sm:text-4xl">
                            Le risposte che cercano le imprese del Sud.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <p className="mt-6 text-base leading-relaxed text-[#475569]">
                            Officine, gommisti, carrozzerie, concessionarie, mezzi pesanti, autolavaggi e flotte: in breve, quello che ci chiedono più spesso le imprese di Cosenza, della Calabria e del Sud Italia.
                        </p>
                    </Reveal>
                </div>
                <div className="lg:col-span-8">
                    {FAQ_GROUPS.map((g, gi) => (
                        <Reveal key={g.title} delay={0.08 + gi * 0.04}>
                            <div className={gi > 0 ? "mt-8" : ""} data-testid={`faq-group-${gi}`}>
                                <h3 className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-[#E30613]">{g.title}</h3>
                                <div className="rounded-3xl border border-slate-200 bg-white px-6 sm:px-8" data-testid={`faq-accordion-${gi}`}>
                                    {g.items.map((item) => (
                                        <FaqItem key={item.q} item={item} index={FAQ.indexOf(item)} group={`faq-group-${gi}`} />
                                    ))}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
